/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Stage } from './Stage';
import {
    StageFromJSON,
    StageFromJSONTyped,
    StageToJSON,
    StageToJSONTyped,
} from './Stage';

/**
 * Serializer for ShowStage through model.
 * @export
 * @interface ShowStage
 */
export interface ShowStage {
    /**
     * 
     * @type {string}
     * @memberof ShowStage
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof ShowStage
     */
    show: string;
    /**
     * 
     * @type {Stage}
     * @memberof ShowStage
     */
    readonly stage: Stage;
    /**
     * 
     * @type {string}
     * @memberof ShowStage
     */
    stageId: string;
    /**
     * Main stage for this show
     * @type {boolean}
     * @memberof ShowStage
     */
    isPrimary?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowStage
     */
    notes?: string;
    /**
     * 
     * @type {Date}
     * @memberof ShowStage
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ShowStage
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the ShowStage interface.
 */
export function instanceOfShowStage(value: object): value is ShowStage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('show' in value) || value['show'] === undefined) return false;
    if (!('stage' in value) || value['stage'] === undefined) return false;
    if (!('stageId' in value) || value['stageId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ShowStageFromJSON(json: any): ShowStage {
    return ShowStageFromJSONTyped(json, false);
}

export function ShowStageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowStage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'show': json['show'],
        'stage': StageFromJSON(json['stage']),
        'stageId': json['stage_id'],
        'isPrimary': json['is_primary'] == null ? undefined : json['is_primary'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function ShowStageToJSON(json: any): ShowStage {
      return ShowStageToJSONTyped(json, false);
  }

  export function ShowStageToJSONTyped(value?: Omit<ShowStage, 'id'|'stage'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'show': value['show'],
        'stage_id': value['stageId'],
        'is_primary': value['isPrimary'],
        'notes': value['notes'],
    };
}

